import { useMergeRefs } from '@floating-ui/react'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { FloatingTooltip } from '../../../Floating'

import { QA_NAME_CALENDAR_GRID_BLOCK } from './CalendarGridWeekBlock.constants'
import {
  getIsCalendarGridWeekBlockSecondaryLabelHidden,
  getIsCalendarGridWeekBlockTooltipDisabled,
} from './CalendarGridWeekBlock.utils'
import { CalendarGridWeekBlockContent } from './CalendarGridWeekBlockContent'
import { CalendarGridWeekBlockTooltipContent } from './CalendarGridWeekBlockTooltipContent'

import * as styles from './CalendarGridWeekBlock.module.css'

function CalendarGridWeekBlock({
  className = styles.CalendarGridWeekBlock,
  elementRef,
  hint,
  isCompact,
  isDisabled,
  isHintDetailed,
  isSecondaryLabelPinned,
  qaContext,
  ref,
  secondaryLabel,
  style,
  timeLabel,
  title,
  variant,
  onClickSecondaryLabel,
  ...restProps
}) {
  const mergedRef = useMergeRefs([elementRef, ref])

  return (
    <FloatingTooltip
      content={
        <CalendarGridWeekBlockTooltipContent
          hint={hint}
          isHintDetailed={isHintDetailed}
          timeLabel={timeLabel}
          title={title}
        />
      }
      disabled={getIsCalendarGridWeekBlockTooltipDisabled({
        hint,
        isHintDetailed,
      })}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <div
        {...restProps}
        {...getQaSelector({
          context: qaContext,
          value: QA_NAME_CALENDAR_GRID_BLOCK,
        })}
        className={classNames(className, styles[variant], {
          [styles.compact]: isCompact,
          [styles.disabled]: isDisabled,
        })}
        ref={mergedRef}
        style={style}
      >
        <CalendarGridWeekBlockContent
          secondaryLabel={
            getIsCalendarGridWeekBlockSecondaryLabelHidden({
              isCompact,
              isSecondaryLabelPinned,
            })
              ? null
              : secondaryLabel
          }
          timeLabel={timeLabel}
          title={title}
          onClickSecondaryLabel={onClickSecondaryLabel}
        />
      </div>
    </FloatingTooltip>
  )
}

export default CalendarGridWeekBlock
